// extracted by mini-css-extract-plugin
export default {"font-serif":"font-serif_A1SKw","cityImage":"cityImage_EE8Am","cityName":"cityName_dJD48"};